import { render, staticRenderFns } from "./landZhuan.vue?vue&type=template&id=26917be5&scoped=true"
import script from "./landZhuan.vue?vue&type=script&lang=js"
export * from "./landZhuan.vue?vue&type=script&lang=js"
import style0 from "./landZhuan.vue?vue&type=style&index=0&id=26917be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26917be5",
  null
  
)

export default component.exports